<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <div style="display: flex">
          <div class="sample-image">
            <el-image
              :src="
                formData.displayImageUrl
                  ? $osscdn(formData.displayImageUrl)
                  : '/image/static/img/nopic.jpg'
              "
              :fit="'cover'"
              :preview-src-list="[
                formData.displayImageUrl
                  ? $osscdn(formData.displayImageUrl)
                  : '/image/static/img/nopic.jpg',
              ]"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 337px; height: 224px"
                />
              </div>
            </el-image>
            <div class="expoinfo-name">
              {{ formData.expoInfoName }}
            </div>
          </div>
          <div style="min-height: 224px; width: 700px; margin-left: 22px">
            <SapmleInfo :data="formData" />
          </div>
        </div>
      </el-col>

      <el-col :span="24">
        <div style="display: flex">
          <div style="width: 337px">
            <CommentsCard
              :selectionCode="selectionCode"
              :expoMeetingCode="expoMeetingCode"
              recordType="P"
            />
          </div>
          <div style="width: 700px; margin-left: 22px; margin-top: 27px">
            <SelectionRemark
              ref="tskInfo"
              v-model="formData.selectionRemark"
              :disabled="disabled"
              :expoMeetingCode="expoMeetingCode"
              :taskCode="formData.taskCode"
              :selectionCode="formData.selectionCode"
              :expoInfoCode="formData.expoInfoCode"
              @reload="() => $emit('reload')"
              @close="() => $emit('close')"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import SapmleInfo from '../sapmle-info'
import CommentsCard from '../comments-card'
import SelectionRemark from '../selection-remark'
export default {
  mixins: [EditLoading],
  components: { SapmleInfo, CommentsCard, SelectionRemark },
  props: {
    disabled: { type: Boolean, default: false },
    selectionCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      localTimeZone: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.selectionCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingSelectionDetailApi({
          selectionCode: this.selectionCode,
          localTimeZone,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    async save() {
      this.$refs.tskInfo.save()
    },
    cancel() {
      this.$refs.tskInfo.cancel()
    },
  },
}
</script>
<style lang="scss" scoped>
.sample-image {
  // width: 100%;
  // height: 100%;
  width: 337px;
  height: 224px;
  aspect-ratio: 3 / 2;
  position: relative;
  display: flex;
  justify-content: center;
  border: 1px #f1f1f2 solid;
  // align-items: center;
  .expoinfo-name {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.2);
    color: rgba(96, 98, 102, 1);
    text-align: center;
    padding: 8rpx 0;
  }
}
</style>
